import type {ExampleData, DataCallbackOptions} from '../../Common';
import {addPerspectiveCameraOBJWithOrbitControls} from '../../ExampleUtils';

export function createData(options: DataCallbackOptions): ExampleData {
	const {scene} = options;
	const root = scene.root();
	const geo = root.createNode('geo');
	const sphere = geo.createNode('sphere');

	// add a light
	root.createNode('hemisphereLight');

	const {perspectiveCamera1} = addPerspectiveCameraOBJWithOrbitControls(root);

	return {
		scene,
		cameraPath: perspectiveCamera1.path(),
		focusedNodes: [sphere],
		autoLayout: true,
	};
}
// export const sopSphere = [
// 	new Example({
// 		name: `${ExamplePrefix.BY_NODE}/sop/sphere/default`,
// 		createData,
// 		relatedNodes: [SphereSopNode],
// 	}),
// ];
